import { useMemo } from 'react';
import useHeaderMenuData from '@/creditflowresearch/application/HeaderMenu/useHeaderMenuData';
import { HeaderMappingItem } from '@/creditflowresearch/application/actions/profile/helpers/types';
import { checkModuleVisibility } from '../checkModuleVisibility';
import { useProductRegionIds } from './useProductRegionIds';

export interface IUseModuleVisibilityDeps {
  mapping?: Record<string, HeaderMappingItem> | null,
  productIds?: string[],
  regionIds?: string[],
}

export const useModuleVisibility = (
  moduleName: string,
  deps?: IUseModuleVisibilityDeps,
): boolean => {
  const headerMenuData = useHeaderMenuData();
  const productRegionContext = useProductRegionIds();

  const mapping = deps?.mapping ?? headerMenuData.mapping;
  const productIds = deps?.productIds ?? productRegionContext.productIds;
  const regionIds = deps?.regionIds ?? productRegionContext.regionIds;

  return useMemo(
    () => checkModuleVisibility({ mapping, productIds, regionIds, moduleName }),
    [mapping, productIds, regionIds, moduleName],
  );
};
